import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
// const GOOGLE_CLIENT_ID = '667384113615-2pu2phiuuaa3krdqvff3e8g76eckpo45.apps.googleusercontent.com';
const GOOGLE_CLIENT_ID = '461414115972-ohitb05nm54jg9aej68sfp3vf0ciu262.apps.googleusercontent.com';


export default function GoogleSignInButton() {
  const { loginWithGoogle } = useAuth();
  const navigate = useNavigate();
  const btnRef = useRef(null);
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current || !window.google) return;
    initialized.current = true;

    window.google.accounts.id.initialize({
      client_id: GOOGLE_CLIENT_ID,
      callback: handleCredentialResponse,
    });
    window.google.accounts.id.renderButton(btnRef.current, {
      theme: 'outline',
      size: 'large',
      text: 'continue_with',
      shape: 'rectangular',
      width: '400',
    });
  }, []);

  const handleCredentialResponse = async (response) => {
    console.log('Google credential response:', response);   // ✅ inspect

    if (!response?.credential) {
      alert('No credential returned from Google. Please try again.');
      return;
    }

    try {
      await loginWithGoogle(response.credential);
      navigate('/');
    } catch (err) {
      console.error('Google login error:', err.response?.data || err.message);
      alert('Google sign‑in failed. Check the console for details.');
    }
  };

  return <div ref={btnRef}></div>;
}